import { useContext, useEffect, useState } from "react";
import styles from "./sidebar.module.css";
import { UserContext } from "../../context/userContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
const fullMenu = [
  {
    icon: "/icons/sidebar/dashboardLight.svg",
    title: "Dashboard",
    path: "/dashboard",
    index: 0,
  },
  { icon: "/icons/sidebar/user.svg", title: "Users", path: "/users", index: 1 },
  {
    icon: "/icons/sidebar/assets.svg",
    title: "Assets",
    path: "/report/assets",
    index: 3,
  },
  {
    icon: "/icons/sidebar/subscription.svg",
    title: "Subscriptions",
    path: "/report/subscription",
    index: 4,
  },
  // {
  //   icon: "/icons/sidebar/assets.svg",
  //   title: "Reports",
  //   index: 2,
  //   subMenu: [
  //     {
  //       icon: "/icons/sidebar/assets.svg",
  //       title: "Assets",
  //       path: "/report/assets",
  //       index: 3,
  //     },
  //     {
  //       icon: "/icons/sidebar/subscription.svg",
  //       title: "Subscriptions",
  //       path: "/report/subscription",
  //       index: 4,
  //     },
  //     {
  //       icon: "/icons/sidebar/subscription.svg",
  //       title: "Income",
  //       path: "/report/rewards",
  //       index: 5,
  //     },
  //     {
  //       icon: "/icons/sidebar/subscription.svg",
  //       title: "Total Deposit Report (AV)",
  //       path: "/report/depositReport",
  //       index: 6,
  //     },
  //   ],
  // },
  {
    icon: "/icons/sidebar/withdraw.svg",
    title: "Withdraw",
    path: "/withdraw",
    index: 7,
  },
  // {
  //   icon: "/icons/sidebar/banner.svg",
  //   title: "Rank Income",
  //   path: "/rank-income",
  //   index: 8,
  // },
  // {
  //   icon: "/icons/sidebar/support.svg",
  //   title: "Fees Management",
  //   path: "/reward-bonus",
  //   index: 9,
  // },
  // {
  //   icon: "/icons/sidebar/prediction.svg",
  //   title: "Site Maintenance",
  //   path: "/site-maintenance",
  //   index: 10,
  // },
  // {
  //   icon: "/icons/sidebar/prediction.svg",
  //   title: "Matching Rewards",
  //   path: "/matching-reward",
  //   index: 11,
  // },
  // {
  //   icon: "/icons/sidebar/support.svg",
  //   title: "Banner Management",
  //   path: "/banner",
  //   index: 12,
  // },
  // {
  //   icon: "/icons/sidebar/support.svg",
  //   title: "Support",
  //   path: "/support",
  //   index: 13,
  // },
  // {
  //   icon: "/icons/sidebar/lock.svg",
  //   title: "Change Pass",
  //   path: "/password",
  //   index: 14,
  // },
  {
    icon: "/icons/sidebar/lock.svg",
    title: "Logout",
    path: "/login",
    index: 15,
  },
];

const restrictedAdminMenu = [
  {
    icon: "/icons/sidebar/subscription.svg",
    title: "Plan Data",
    path: "/plandata",
    index: 0,
  },
  {
    icon: "/icons/sidebar/prediction.svg",
    title: "Plan Data Completed",
    path: "/plandataCompleted",
    index: 1,
  },
  {
    icon: "/icons/sidebar/lock.svg",
    title: "Logout",
    path: "/login",
    index: 2,
  },
];

export default function Sidebar() {
  const {
    activeTab,
    setActiveTab,
    showSidebar,
    setShowSidebar,
    setUserLoggedIn,
    setUserToken,
    isAdmin,
  } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();

  const menu = isAdmin === 2 ? restrictedAdminMenu : fullMenu;

  const [expandedReports, setExpandedReports] = useState(false);

  useEffect(() => {
    console.log("Current path:", location.pathname);
    console.log(
      "Menu paths:",
      menu.map((m) => m.path)
    );
  }, [location.pathname, menu]);

  useEffect(() => {
    const matchingMainItem = menu.find(
      (route) => route.path === location.pathname
    );
    console.log(matchingMainItem, "matchingMainItem");

    if (matchingMainItem) {
      setActiveTab(matchingMainItem.index);
    } else {
      const matchingSubMenuItem = menu
        .filter((item) => item.subMenu) // Only items that have subMenu
        .map((item) => item.subMenu) // Get all subMenu arrays
        .flat() // Flatten to a single array of subMenu items
        .find((subItem) => subItem.path === location.pathname); // Find matching subMenu path

      if (matchingSubMenuItem) {
        setActiveTab(matchingSubMenuItem.index);
      }
    }
  }, [location.pathname, setActiveTab, menu]);

  const toggleReportsDropdown = () => {
    setExpandedReports(!expandedReports);
  };

  return (
    <div
      className={styles.sidebarContainer}
      style={{
        width: showSidebar ? "250px" : "45px",
        overflow: showSidebar ? "visible" : "hidden",
      }}
    >
      <Link to="/dashboard" onClick={() => setActiveTab(0)}>
        <div
          className={styles.sidebarImgBox}
          style={{
            opacity: showSidebar ? "1" : "0",
          }}
        >
          <img src="/logo.png" alt="logo" className={styles.sidebarLogo} />
        </div>
      </Link>
      <div
        className={styles.pinBox}
        onClick={() => {
          setShowSidebar(!showSidebar);
          localStorage.setItem("showSidebar", !showSidebar);
        }}
        style={{
          transform: !showSidebar ? "rotate(180deg)" : "rotate(0deg)",
          right: showSidebar ? "-12px" : "10px",
        }}
      >
        <FaChevronLeft />
      </div>

      {menu.map((item, index) => {
        if (item.subMenu) {
          return (
            <div key={index}>
              <div
                className={`${styles.sidebarChild} ${
                  activeTab === item.index ? styles.activeChildTab : ""
                }`}
                onClick={toggleReportsDropdown}
              >
                <img src={item?.icon} alt="logo" />
                <p>{item?.title}</p>
              </div>

              {expandedReports && (
                <div className={styles.subNav}>
                  {item.subMenu.map((subItem) => (
                    <Link to={subItem.path} key={subItem.index}>
                      <div
                        className={`${styles.sidebarChild} ${
                          activeTab === subItem.index
                            ? styles.activeChildTab
                            : ""
                        }`}
                        onClick={() => {
                          setActiveTab(subItem.index);
                        }}
                      >
                        <img src={subItem.icon} alt={subItem.title} />
                        <p>{subItem.title}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        }

        return (
          <Link to={item.path} key={index}>
            <div
              className={`${styles.sidebarChild} ${
                activeTab === item.index ? styles.activeChildTab : ""
              }`}
              onClick={() => {
                setActiveTab(item.index);
                if (item.title === "Logout") {
                  setUserLoggedIn(false);
                  setUserToken("");
                  localStorage.clear();
                  navigate("/");
                }
              }}
            >
              <img src={item?.icon} alt="logo" />
              <p>{item?.title}</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
